<template>
  <div :class="$vuetify.breakpoint.name === 'lg' ? 'px-2' : 'px-5'">
    <Snackbar :snackbar="snackbar" :text="text" :timeout="timeout"></Snackbar>

    <v-dialog v-model="dialog.detail" persistent width="650">
      <v-card>
        <v-card-title
          class="background-first body-2 white--text py-1 pl-5 pr-2"
        >
          <span>Detail</span>
          <v-spacer />
          <v-btn
            color="#0299B7"
            small
            elevation="0"
            fab
            class="text-capitalize color-first"
            @click="dialog.detail = false"
          >
            <v-icon small color="#FFFFFF">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12">
              <table
                width="100%"
                style="
                  font-family: Arial, Helvetica, sans-serif;
                  line-height: 1.7;
                  font-size: 14px;
                "
              >
                <tr>
                  <td width="35%">Nama lengkap</td>
                  <td width="3%">:</td>
                  <td>{{ detail.nama || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Email aktif</td>
                  <td width="3%">:</td>
                  <td>{{ detail.email || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Nomor induk kepegawaian</td>
                  <td width="3%">:</td>
                  <td>{{ detail.nip || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">No. WhatsApp aktif</td>
                  <td width="3%">:</td>
                  <td>{{ detail.whatsapp || "-" }}</td>
                </tr>
                <tr>
                  <td width="35%">Status</td>
                  <td width="3%">:</td>
                  <td>{{ detail.status || "-" }}</td>
                </tr>
              </table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider
          style="border-color: #bac0c6; border-radius: 25px"
        ></v-divider>
        <v-card-actions class="mt-2 pb-3 justify-center">
          <v-btn
            outlined
            class="text-capitalize color-first mx-1"
            :disabled="process.form"
            @click="dialog.detail = false"
          >
            Kembali
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <LoadingComponent v-if="process.loading"></LoadingComponent>

    <v-row
      class="mt-3"
      :class="$vuetify.breakpoint.name !== 'xs' ? 'px-3' : 'pr-0 pl-3'"
      v-if="!process.loading"
    >
      <v-col cols="12">
        <v-card class="border-radius box-shadow pa-1">
          <v-row>
            <v-col cols="12" class="py-0">
              <v-card-text>
                <div class="color-first title font-weight-bold title mt-3">
                  Dosen
                </div>

                <v-row class="pt-5">
                  <v-col cols="12" md="3">
                    <v-select
                      dense
                      :disabled="process.run"
                      outlined
                      :items="list.status"
                      item-text="nama"
                      item-value="id"
                      v-model="filter.status"
                      v-on:change="getList()"
                      label="Status"
                      color="#0299B7"
                      hide-details
                    >
                      <template v-slot:append>
                        <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                      </template>
                    </v-select>
                  </v-col>
                </v-row>

                <v-row class="mt-7 justify-space-between">
                  <v-col cols="12" md="3">
                    <v-btn
                      @click="addForm()"
                      color="#0299B7"
                      elevation="0"
                      :disabled="process.run"
                      class="text-capitalize white--text"
                    >
                      <v-icon size="20" class="mr-3">mdi-plus</v-icon>
                      Tambah dosen
                    </v-btn>
                  </v-col>

                  <v-col cols="12" md="4">
                    <v-text-field
                      :disabled="process.run"
                      outlined
                      dense
                      :hide-details="true"
                      placeholder="Cari . . ."
                      clearable
                      color="#0299B7"
                      class="mx-3"
                      v-model="filter.search"
                      @click:clear="
                        filter.search = '';
                        getList();
                      "
                      v-on:keyup.enter="getList()"
                      prepend-inner-icon="mdi-magnify"
                    >
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-card-text
                  class="pa-5 px-0"
                  style="height: calc(100vh - 195px)"
                >
                  <v-skeleton-loader
                    :loading="process.run"
                    transition="scale-transition"
                    :tile="false"
                    :style="process.run ? 'height: calc(100vh - 305px)' : ''"
                    type="table-tbody"
                  >
                    <v-data-table
                      :headers="headers"
                      :items="filteredRows"
                      :items-per-page="10"
                      class="elevation-1 required"
                    >
                      <template v-slot:[`item.status`]="{ item }">
                        <td>
                          <span :class="getStatusClass(item.status)">{{
                            item.status
                          }}</span>
                        </td>
                      </template>
                      <template v-slot:[`item.aksi`]="{ item }">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="30"
                              color="orange"
                              :disabled="process.run"
                              @click="editForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                          </template>
                          <span>Edit</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              x-small
                              fab
                              icon
                              min-width="25"
                              color="#0299B7"
                              :disabled="process.run"
                              @click="detailForm(item)"
                              class="text-capitalize color-first pa-0 mx-1"
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>Detail</span>
                        </v-tooltip>
                      </template>
                    </v-data-table>
                  </v-skeleton-loader>
                </v-card-text>
              </v-card-text>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from "@/service/Axios";
import { TokenService } from "@/service/Storage.Service";
import statusMixin from "@/mixin";
import Snackbar from "@/components/Snackbar.vue";
import LoadingComponent from "@/components/Loading.vue";

export default {
  mixins: [statusMixin],
  data() {
    return {
      detail: {},
      dialog: {
        detail: false
      },
      filter: {
        search: "",
        status: "all"
      },
      rows: [],
      headers: [
        { text: "No.", value: "no", sortable: false },
        { text: "Nama", value: "nama", sortable: false },
        { text: "Email", value: "email", sortable: false },
        { text: "Nomor Induk Kepegawaian", value: "nip", sortable: false },
        { text: "No. WhatsApp aktif", value: "whatsapp", sortable: false },
        { text: "Status", value: "status", sortable: false, width: "11%" },
        { text: "Aksi", value: "aksi", align: "center", width: "12%" }
      ],
      list: {
        status: [
          { id: "all", nama: "Semua" },
          { id: "1", nama: "Aktif" },
          { id: "0", nama: "Tidak aktif" }
        ]
      },
      process: {
        run: false,
        form: false,
        loading: false
      },
      snackbar: false,
      text: "",
      timeout: 3000
    };
  },
  components: {
    Snackbar,
    LoadingComponent
  },
  computed: {
    filteredRows() {
      if (this.filter.status === "all") {
        return this.rows;
      }

      return this.rows.filter(
        (row) => String(row.flag_aktif) === this.filter.status
      );
    }
  },
  mounted() {
    this.getList();
  },
  methods: {
    async getList() {
      this.startLoading();
      try {
        const params = {
          search: this.filter.search
        };
        if (this.filter.status !== "all") {
          params.flag_aktif = this.filter.status;
        }
        const response = await get("lecturer-master", { params });
        if (response.status === 200) {
          const res = response.data.data || [];
          this.rows = res.map((item, index) => this.mapLecturer(item, index));
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.stopLoading();
      }
    },

    mapLecturer(item, index) {
      let flagAktif = 1;
      if (item.flagAktif !== undefined && item.flagAktif !== null) {
        flagAktif = Number(item.flagAktif);
      } else if (item.flag_aktif !== undefined && item.flag_aktif !== null) {
        flagAktif = Number(item.flag_aktif);
      }

      const nip =
        item.nipDosen ||
        item.noInduk ||
        item.noIndukKepegawaian ||
        item.no_induk_kepegawaian ||
        item.nik ||
        "-";

      const whatsapp =
        item.no_telepon ||
        item.noTelepon ||
        item.noWhatsapp ||
        item.no_whatsapp ||
        item.noHp ||
        "-";

      return {
        no: index + 1,
        nama: item.namaDosen || item.nama || "-",
        email: item.email || "-",
        nip: nip,
        whatsapp: whatsapp,
        no_telepon: whatsapp,
        status: flagAktif === 1 ? "Aktif" : "Tidak aktif",
        flag_aktif: flagAktif,
        uuid: item.uuid || "",
        raw: item
      };
    },

    addForm() {
      TokenService.removeUUID(TokenService.getUuid());
      localStorage.removeItem("lecturer_detail");
      this.$router.push("/dosen/tambah");
    },

    editForm(item) {
      // Ensure we pick the exact source row from `this.rows` to avoid
      // wrong selections after filtering/pagination.
      let srcCandidate = item.raw || item || {};

      // Prefer matching by uuid when available
      if (item && item.uuid) {
        const found = this.rows.find((r) => r.uuid && r.uuid === item.uuid);
        if (found) srcCandidate = found.raw || found;
      } else if (item && item.email) {
        // fallback: match by email+name to be safer
        const found = this.rows.find(
          (r) =>
            (r.email || r.raw?.email) === item.email &&
            (r.nama || r.raw?.nama) === item.nama
        );
        if (found) srcCandidate = found.raw || found;
      } else if (item && item.nip) {
        const found = this.rows.find(
          (r) => (r.nip || r.raw?.nip || r.raw?.noInduk) === item.nip
        );
        if (found) srcCandidate = found.raw || found;
      }

      const src = srcCandidate || item || {};
      const normalized = {
        nama: src.namaDosen || src.nama || "",
        email: src.email || src.userEmail || "",
        nip:
          src.nipDosen ||
          src.noInduk ||
          src.noIndukKepegawaian ||
          src.no_induk_kepegawaian ||
          src.nip ||
          src.nik ||
          "",
        whatsapp:
          src.no_telepon || src.noWhatsapp || src.no_whatsapp || src.noHp || "",
        no_telepon:
          src.no_telepon || src.noWhatsapp || src.no_whatsapp || src.noHp || "",
        flag_aktif:
          src.flagAktif !== undefined
            ? src.flagAktif
            : src.flag_aktif !== undefined
            ? src.flag_aktif
            : 1,
        uuid: src.uuid || item.uuid || ""
      };

      localStorage.setItem("lecturer_detail", JSON.stringify(normalized));
      if (normalized.uuid) {
        TokenService.setUuid(normalized.uuid);
      } else {
        TokenService.removeUUID(TokenService.getUuid());
      }
      this.$router.push("/dosen/edit");
    },

    detailForm(item) {
      // prefer original backend fields so detail modal shows actual email
      const src = item.raw || item || {};
      const flagAktif =
        src.flagAktif !== undefined && src.flagAktif !== null
          ? Number(src.flagAktif)
          : src.flag_aktif !== undefined && src.flag_aktif !== null
          ? Number(src.flag_aktif)
          : 1;

      const normalized = {
        nama: src.namaDosen || src.nama || "-",
        email: src.email || src.userEmail || src.emailAktif || "-",
        nip:
          src.nipDosen ||
          src.noInduk ||
          src.noIndukKepegawaian ||
          src.no_induk_kepegawaian ||
          src.nip ||
          src.nik ||
          "-",
        whatsapp:
          src.no_telepon ||
          src.noWhatsapp ||
          src.no_whatsapp ||
          src.noHp ||
          "-",
        no_telepon:
          src.no_telepon ||
          src.noWhatsapp ||
          src.no_whatsapp ||
          src.noHp ||
          "-",
        status: flagAktif === 1 ? "Aktif" : "Tidak aktif"
      };

      this.detail = normalized;
      this.dialog.detail = true;
    }
  }
};
</script>
